import { RefObject, useEffect, useRef } from 'react';

function useLazyLoadImage(
  backgroundImage: string | undefined,
): RefObject<HTMLImageElement> {
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const imgElement = imgRef.current;
    if (!imgElement || !backgroundImage) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          imgElement.style.backgroundImage = `url(${backgroundImage})`;
          observer.unobserve(imgElement);
        }
      });
    });

    observer.observe(imgElement);

    return () => {
      if (imgElement) {
        observer.unobserve(imgElement);
      }
    };
  }, [backgroundImage]);

  return imgRef;
}

export default useLazyLoadImage;
